import React, { useEffect } from "react";
import { CssBaseline, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import ContactInformation from "./ContactInformation";
import { homePagePath } from "../constant";

const ChildSafetyPage = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const backToHome = () => {
    isLoggedIn ? navigate("/dashboard") : navigate(homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div style={{ width: "100%" }}> <CssBaseline /> <Navbar />

      
      <div className={`main-container ${!isLoggedIn && "no-auth"}`}>
        <div className="event-service-head-inner-policy">
          <div>
            <button
              className="back-to-services-btn"
              onClick={backToHome}
            >
              <i className="pi pi-arrow-left"></i> Home
            </button>
          </div>
        </div>

        <div className="center-heading">
          <h1>Child Safety Standards</h1>
        </div>

        <div className="frontend-container">
          <div style={{ width: "100%" }}>
            <div className="event-form-inner">
              <div className="event-form-body alter full">
                <div className="event-form-content">

                  <p>
                    <strong>Last Updated:</strong> July 2026
                  </p>

                  <h2>Our Commitment to Child Safety</h2>

                  <p>
                    THURENT TECH SERVICES PRIVATE LIMITED ("Thurent")
                    is committed to maintaining a safe and secure platform
                    for all users. Thurent has a zero-tolerance policy
                    against Child Sexual Abuse and Exploitation (CSAE)
                    and Child Sexual Abuse Material (CSAM).
                  </p>

                  <div
                    style={{
                      background: "#fff3cd",
                      borderLeft: "4px solid #ffc107",
                      padding: "16px",
                      margin: "20px 0",
                    }}
                  >
                    <strong>Zero-Tolerance Policy:</strong>
                    <p style={{ marginTop: 8 }}>
                      Thurent strictly prohibits any content,
                      communication, activity, or behavior that
                      exploits, abuses, endangers, or harms children.
                    </p>
                  </div>

                  <h2>Prohibited Content and Activities</h2>

                  <p>Users must not:</p>

                  <ul>
                    <li>
                      Create, upload, share, transmit, or distribute
                      Child Sexual Abuse Material (CSAM).
                    </li>
                    <li>
                      Engage in, promote, facilitate, or encourage
                      Child Sexual Abuse and Exploitation (CSAE).
                    </li>
                    <li>
                      Attempt to contact, groom, manipulate,
                      exploit, or harm minors.
                    </li>
                    <li>
                      Use Thurent to organize, promote,
                      or facilitate illegal activities involving minors.
                    </li>
                    <li>
                      Share content that sexualizes, exploits,
                      or endangers children.
                    </li>
                    <li>
                      Impersonate minors or misrepresent age
                      for unlawful purposes.
                    </li>
                  </ul>

                  <h2>Reporting Child Safety Violations</h2>

                  <p>
                    Thurent provides mechanisms for users to report
                    content, profiles, messages, or activities that
                    may violate these Child Safety Standards.
                  </p>

                  <p>
                    Users are encouraged to report suspicious,
                    exploitative, abusive, or inappropriate
                    content involving minors immediately.
                  </p>

                  <h2>Enforcement Actions</h2>

                  <p>
                    Upon receiving a report or identifying a violation,
                    Thurent may:
                  </p>

                  <ul>
                    <li>Remove offending content immediately.</li>
                    <li>Suspend or permanently terminate accounts.</li>
                    <li>Restrict access to platform features.</li>
                    <li>Preserve evidence as required by law.</li>
                    <li>
                      Report violations to law enforcement
                      authorities and child protection organizations.
                    </li>
                  </ul>

                  <h2>Cooperation with Authorities</h2>

                  <p>
                    Thurent cooperates with law enforcement agencies,
                    regulatory authorities, and child protection
                    organizations in accordance with applicable laws.
                  </p>

                  <h2>Content Moderation</h2>

                  <p>
                    Thurent actively reviews reports submitted by users
                    and may use manual moderation processes and
                    automated detection systems to identify and address
                    violations of these standards.
                  </p>

                  <h2>Compliance with Laws</h2>

                  <p>
                    Thurent complies with all applicable child safety,
                    online safety, privacy, and content moderation laws.
                    Users are expected to comply with these laws while
                    using the platform.
                  </p>

                  <Box sx={{ my: 4 }}>
                    <ContactInformation title="Child Safety Contact" />
                  </Box>

                  <h2>Updates to These Standards</h2>

                  <p>
                    Thurent may update these Child Safety Standards
                    periodically to comply with legal requirements,
                    platform policies, and industry best practices.
                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ConfirmDialog />
    </div>

  );
};

export default ChildSafetyPage;
